import router from '../../router'

const state = {
    RouteName: '',
    isCollapse: false,
    upload_data:"",
    router_true:true,//路由是否跳转
    data_no_router:false,//路由弹框
    // from_path:'',
    to_path:'',

}
const actions = {
    RouterAuth: ({
        commit
    }) => {
        router.beforeEach((to, from, next) => {

            // /blockchain_d/deposit
            // kyc_status: KYC状态 0没有 1保存未提交 2 待审核   3一审通过  4审核通过  5审核失败
            // 4审核通过 路由才能跳转
            let kyc_status=sessionStorage.getItem("kyc_status");
            // console.log(kyc_status);
            if(kyc_status&&kyc_status!=4){
                if((to.path.indexOf('blockchain_d') != -1)||(to.path.indexOf('blockchain_w') != -1)){
                    router.push('/');
                }
            }

            if(state.router_true==false){
                state.data_no_router=true;
                state.to_path=to.path;
                return ;
            }


            commit; from;next();
            let token = sessionStorage.getItem('token');
            state.RouteName = to.path;
            let status=localStorage.getItem('approve_status');
            // approve_status: 认证状态 0 没有 1待审核 2审核通过 3审核失败
            // 0 3 需要上传才能进入首页
            let upload_data="";
            upload_data; token;
            if(status==0||status==3){
                upload_data=false;
            }else{
                upload_data=true;
            }

            if(Object.is(to.name, 'all_apply_card_input')
                ||Object.is(to.name, 'all_apply_card_info')
                ||Object.is(to.name, 'all_apply_card_input_custom')
                ||Object.is(to.name, 'all_apply_card_info_custom')
                ||Object.is(to.name, 'all_apply_card_input_qrcode')
                ||Object.is(to.name, 'all_apply_card_info_qrcode')
                ||Object.is(to.name, 'all_apply_card_aisport')
                ||Object.is(to.name, 'visionlife_input')
                ||Object.is(to.name, 'visionlife_info')
              ){
                if(token&&upload_data){
                    next()
                }else{
                    next();
                }
                return false
            }


                if(Object.is(to.name, 'login')||Object.is(to.name, 'reg')||Object.is(to.name, 'reset_pwd')||Object.is(to.name, 'forget_pwd')||Object.is(to.name, 'upload')){
                    if(token&&upload_data){
                        // next('/')
                        const userType = sessionStorage.getItem("userType");
                        if(userType == 1){
                            this.$router.push("/");
                          }else{
                            const authjson = JSON.parse(sessionStorage.getItem("authjson"))[0];
                            if(authjson==1){
                              this.$router.push("/");
                            }else if(authjson==2){
                              this.$router.push("/my_transaction");
                            }else if(authjson==3){
                              if(authjson.includes(["3-1"])){
                                this.$router.push("/blockchain_d/deposit_fiat");
                              }else{
                                this.$router.push("/blockchain_d/deposit_jmhb");
                              }
                            }else if(authjson==4){
                              this.$router.push("/cards_view");
                            }else if(authjson==5){
                              this.$router.push("/otc");
                            }else if(authjson==6){
                              this.$router.push("/private_b_p");
                            }else if(authjson==7){
                              this.$router.push("/structured_p");
                            }else if(authjson==8){
                              this.$router.push("/investment_b");
                            }else if(authjson==9){
                              if(authjson.includes(["9-1"])){
                                this.$router.push("/contract_management");
                              }else{
                                this.$router.push("/card_management");
                              }
                            }else if(authjson==10){
                              this.$router.push("/concealed_accounts");
                            }else if(authjson==11){
                              if(authjson.includes(["11-1"])){
                                this.$router.push("/blockchain_w/transfer_p_fiat");
                              }else{
                                this.$router.push("/blockchain_w/transfer_p_jmhb");
                              }
                            }
                          }

                    }else{
                        next();
                    }
                    return false
                }

                if(Object.is(to.name, 'upload')){
                    if(upload_data){
                        const userType = sessionStorage.getItem("userType");
                        if(userType == 1){
                            this.$router.push("/");
                          }else{
                            const authjson = JSON.parse(sessionStorage.getItem("authjson"))[0];
                            if(authjson==1){
                              this.$router.push("/");
                            }else if(authjson==2){
                              this.$router.push("/my_transaction");
                            }else if(authjson==3){
                              if(authjson.includes(["3-1"])){
                                this.$router.push("/blockchain_d/deposit_fiat");
                              }else{
                                this.$router.push("/blockchain_d/deposit_jmhb");
                              }
                            }else if(authjson==4){
                              this.$router.push("/cards_view");
                            }else if(authjson==5){
                              this.$router.push("/otc");
                            }else if(authjson==6){
                              this.$router.push("/private_b_p");
                            }else if(authjson==7){
                              this.$router.push("/structured_p");
                            }else if(authjson==8){
                              this.$router.push("/investment_b");
                            }else if(authjson==9){
                              if(authjson.includes(["9-1"])){
                                this.$router.push("/contract_management");
                              }else{
                                this.$router.push("/card_management");
                              }
                            }else if(authjson==10){
                              this.$router.push("/concealed_accounts");
                            }else if(authjson==11){
                              if(authjson.includes(["11-1"])){
                                this.$router.push("/blockchain_w/transfer_p_fiat");
                              }else{
                                this.$router.push("/blockchain_w/transfer_p_jmhb");
                              }
                            }
                          }
                    }else{
                        next();
                    }
                    return false;
                }

                if(!Object.is(to.name, 'upload')){
                    if(token&&upload_data==false){
                        next('/upload');
                    }else 
                    if(!token){
                        next('/login');
                    }
                }
                
        })
    }
}

export default {
    namespaced: true,
    state,
    actions,
}